import { render } from "./MyStudentGroupsView.vue?vue&type=template&id=425f6ce4"
import script from "./MyStudentGroupsView.vue?vue&type=script&lang=js"
export * from "./MyStudentGroupsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__